import { StepActionContentComponent } from 'modules/inbox_tasks/tasks/employeeLifecycleStepAction/helpers'

const TrainingContent: StepActionContentComponent = () => null

export default TrainingContent
